
export const name = "UserPreferencesUI";
export const version = "dev";
